<div class="">
  <div class="row justify-content-center container-fullsize">

    <div class="col-12 col-md-8 col-lg-6">

      <div class="card shadow border-0 mt-3">
        <div class="card-header">
          <h3 class="text-center text-muted my-1">
            Acesso ao e-Voto
          </h3>
        </div>

        <div class="card-body px-lg-3 py-lg-3">
          <div class="text-center text-muted mb-4">
            <h5 class="mb-2">Entre com seus dados de acesso</h5>
          </div>

          <form role="form" [formGroup]="formGroup" (ngSubmit)="onSubmit(formGroup.value)">
            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-user" aria-hidden="true"></i></span>
                </div>

                <input class="form-control ext-input p-4" placeholder={{placeHolderLogin}} type="text" formControlName="login">
              </div>

              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('login').valid && formGroup.get('login').touched">
                <small>Informe os dados corretamente para o login</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>
            <!-- mask="000.000.000-00"-->

            <div class="form-group my-3">
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"> <i class="fa fa-key" aria-hidden="true"></i></span>
                </div>
                <input class="form-control ext-input p-4" placeholder="Senha" type="password" maxlength="20"
                  formControlName="senha">
              </div>

              <span class="alert alert-danger m-2 p-1"
                *ngIf="!formGroup.get('senha').valid && formGroup.get('senha').touched">
                <small>Campo senha é obrigatório!</small>
                <i class="fas fa-exclamation ml-2"></i>
              </span>
            </div>
            <div class="mt-3 d-flex justify-content-center">
              <re-captcha (resolved)="resolved($event)" class="mx-2" siteKey="6LdSLSEhAAAAAH1e9FqBRCZj86BewrJ-Iw1Po25H"  *ngIf="mostrarCaptchaV2"></re-captcha>
            </div>
            <div class="text-center mt-5">
              <button type="submit" class="btn btn-outline-info btn-lg btn-block" [disabled]="!formGroup.valid">
                Entrar
                <i class="fas fa-paper-plane ml-2"></i>
              </button>
              <div class="mt-3 d-flex justify-content-center" *ngIf="this.role != '/admin'">
                <a #openModalSenha data-toggle="modal" data-target="#modalSenha" style="color: #FA4616;cursor: pointer;display: none;">Esqueci minha senha</a>
                <a target="_blank" class="align-item-center" (click)="resetPassword()" style="color: #FA4616;cursor: pointer;">Esqueci minha senha</a>
                <div *ngIf="loadModal" class="spinner-border mx-2" style="color: #FA4616" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          </form>

          
          

        </div>

      </div>
    </div>
  </div>
</div>



<!-- TEMPLETE CONFIRM TOAST -->
<p-toast position="center" key="c" (onClose)="okFalhaAutenticaoLogin()" [modal]="true" [baseZIndex]="6000">
  <ng-template let-message pTemplate="message">
    <div class="text-center">
      <i class="pi pi-exclamation-triangle" style="font-size: 3em"></i>
    </div>

    <div class="">
      <h3 class="text-danger text-center">Atenção!</h3>
      <h5 class="text-dark text-center my-2">Falha na autenticação para o
        <strong>USUÁRIO:</strong><strong class="text-info ml-2">{{creds.username}}</strong>
      </h5>
      <h5>{{mensagemError}}</h5>
    </div>

    <div class="ui-g-12">
      <button type="button" pButton (click)="okFalhaAutenticaoLogin()" icon="pi pi-check" label="Tentar Novamente"
        class="ui-button-danger btn-block"></button>

    </div>
  </ng-template>
</p-toast>




<!-- MODAL ALTERAÇÃO DE SENHA -->
<div id="modalSenha" class="modal fade" tabindex="-1" role="dialog" 
  *ngIf = "this.encontrouEleicao != false || this.role == '/gestor' || this.role == '/assistente'">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <!-- HEADER -->
      <div class="modal-header">
        <h5 class="modal-title">Esqueceu sua senha?</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span #closeModalSenha aria-hidden="true">&times;</span>
        </button>
      </div>
      <!-- BODY -->
      <div class="modal-body">
        {{mensagem}}
      </div>
      <div  *ngIf="this.role != '/gestor' && this.role != '/assistente' && this.temIntegracao == false ; else botaoSuporte">
        <div class="modal-footer">
          <div class="col-md-12">
            <form role="form" [formGroup]="formRecuperacaoSenha">
              <div class="form-group my-3">
                <strong for="loginEleitor">{{placeHolderLogin}} *</strong>
                <div class="input-group input-group-alternative">
                  <input class="form-control ext-input p-4"  placeholder={{placeHolderLogin}} type="text" formControlName="loginEleitor">
                </div>
                <span class="alert alert-danger m-2 p-1"
                  *ngIf="!formRecuperacaoSenha.get('loginEleitor').valid && formRecuperacaoSenha.get('loginEleitor').touched">
                  <small>Campo {{placeHolderLogin}} é obrigatório</small>
                  <i class="fas fa-exclamation ml-2"></i>
                </span>
              </div>
              <div class="form-group my-3">
                <strong for="auth1">{{labelAuth1}} *</strong>
                <div class="input-group input-group-alternative">
                  <input class="form-control ext-input p-4" placeholder="Informação de autenticação 1" type="text" formControlName="auth1">
                </div>
                <span class="alert alert-danger m-2 p-1"
                  *ngIf="!formRecuperacaoSenha.get('auth1').valid && formRecuperacaoSenha.get('auth1').touched">
                  <small>Preencha o campo para autenticação</small>
                  <i class="fas fa-exclamation ml-2"></i>
                </span>
              </div>
              <div class="form-group my-3">
                <strong for="auth2">{{labelAuth2}} *</strong>
                <div class="input-group input-group-alternative">
                  <input class="form-control ext-input p-4" placeholder="Informação de autenticação 2" type="text" formControlName="auth2">
                </div>
                <span class="alert alert-danger m-2 p-1"
                  *ngIf="!formRecuperacaoSenha.get('auth2').valid && formRecuperacaoSenha.get('auth2').touched">
                  <small>Preencha o campo para autenticação</small>
                  <i class="fas fa-exclamation ml-2"></i>
                </span>
              </div>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          <div class="col-md-12 text-center">
            <button (click)="alterarSenhaEleitor()" type="button" class="btn btn-outline-info btn-lg btn-block" [disabled]="!formRecuperacaoSenha.valid">ALTERAR MINHA SENHA</button>
          </div>
        </div>
      </div>

      <ng-template #botaoSuporte>
        <div class="modal-footer">
          <div class="col-md-12 text-center" 
          *ngIf = "this.temIntegracao == false">
            <button (click)="abrirChamado()" type="button" class="btn btn-info">SUPORTE SINQIA</button>
          </div>
        </div>
        <div class="modal-footer"
          *ngIf = "this.temIntegracao == true">
          <div class="col-md-12 text-center">
            <button (click)="redicionarSenhaIntegracao()" type="button" class="btn btn-info">ACESSAR SITE</button>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<!---------------------------------------------------------------------------------------- -->
